import { ErrorTypeEnum } from '../shared/enums.model';

export class ErrorObject {
    constructor(public errorText: string,
        public originator: string,
        public errType: ErrorTypeEnum) {
    }
}
